import axiosInstance from '@/api/axiosInstance';

export type accountClassItem = {
  id: string;
  code: string;
  description: string;
  status: 'active' | 'inactive';
};

export interface AccountClassResponse {
  data: {
    data: accountClassItem[];
    total?: number;
  };
  success?: boolean;
  message?: string;
}

type FetchParams = {
  tenantId?: string;
  search?: string;
  limit?: number;
  offset?: number;
  status?: string;
};

export interface CreateAccountClassInput {
  code: string;
  description: string;
  createdByUserId?: string;
  status?: string;
}

export interface editAccountClassInput extends CreateAccountClassInput {
  id?: string;
}

export async function fetchAccountClass(
  params: FetchParams = {}
): Promise<AccountClassResponse> {
  const { tenantId, search, limit, offset, status } = params;
  const response = await axiosInstance.get(
    '/api/v1/financial-settings/account-classes',
    {
      headers: { 'x-tenant-id': tenantId },
      params: {
        // tenantId,
        search,
        sort: 'asc',
        limit,
        offset,
        status: status,
      },
    }
  );
  return response.data as AccountClassResponse;
}

export async function createAccountClass(
  tenantId: string,
  input: CreateAccountClassInput
): Promise<any> {
  const response = await axiosInstance.post(
    '/api/v1/financial-settings/account-classes',
    input,
    {
      headers: {
        'x-tenant-id': tenantId,
      },
    }
  );
  return response.data;
}

export async function editAccountClass(
  id: string,
  tenantId: string,
  input: editAccountClassInput
): Promise<any> {
  const response = await axiosInstance.patch(
    `/api/v1/financial-settings/account-classes/${id}`,
    input,
    {
      headers: {
        'x-tenant-id': tenantId,
      },
    }
  );
  return response.data;
}

export async function updateAccountClassStatus(
  id: string,
  tenantId: string,
  status: string,
  createdByUserId: string
): Promise<any> {
  const response = await axiosInstance.patch(
    `/api/v1/financial-settings/account-classes/updateStatus/${id}`,
    {
      status: status,
      updatedByUserId: createdByUserId,
    },
    {
      headers: { 'x-tenant-id': tenantId },
    }
  );
  return response.data;
}

export async function bulkCreateAccountClass(
  tenantId: string,
  input: CreateAccountClassInput[]
): Promise<any> {
  const response = await axiosInstance.post(
    '/api/v1/financial-settings/account-classes/bulkCreate',
    input,
    {
      headers: { 'x-tenant-id': tenantId },
    }
  );
  return response.data;
}
